import { animate } from "animejs";
import React, { useEffect, useRef } from "react";

interface HeroIconProps extends React.SVGProps<SVGSVGElement> {
  Icon: React.ComponentType<React.SVGProps<SVGSVGElement>>;
  className?: string;
}

const HeroIcon: React.FC<HeroIconProps> = ({ Icon, className, ...props }) => {
  const iconRef = useRef<SVGSVGElement>(null);

  useEffect(() => {
    if (iconRef.current) {
      animate(iconRef.current, {
        rotateY: ["0deg", "180deg"],
        duration: 1000,
        ease: "out(4)",
        loop: true,
        loopDelay: 350,
        color:"white"
      });
    }
  }, []);

  return <Icon ref={iconRef} className={className} {...props} />;
};

export default HeroIcon;
